import api from "./axiosInstance";

// The system value endpoints create one record per request, so a multi-select
// add is sent as a sequence. Names the server rejects (duplicates, validation)
// come back in `failed` instead of aborting the whole batch.
export const bulkCreateSystemValues = async (endpoint, names, buildBody) => {
  const created = [];
  const failed = [];

  for (const name of names) {
    try {
      const body = buildBody ? buildBody(name) : { name, active_flag: true };
      const res = await api.post(endpoint, body);
      created.push(res.data.data);
    } catch (err) {
      failed.push(name);
    }
  }

  return { created, failed };
};
